/**
 * @flow
 * @format
 */

import _ from 'lodash';
import preval from 'babel-plugin-preval/macro';
import debug from './macros/debug.macro';

let prevaled = {
  stepData: {},
  KeyToStepMap: {},
  StepToKeyMap: [],
};

if (process.env.NODE_ENV === 'development') {
  prevaled = require('./stepPreval'); // eslint-disable-line global-require
} else {
  prevaled = preval('module.exports = require("./stepPreval")');
}

export const { StepOrder } = prevaled;
export const getStepDataByKey: (key: string) => StepData = (key: string) =>
  prevaled.stepData[key];

/**
 * Returns the parent step given a field.
 *
 * @export
 * @param {string} field
 * @returns {string | null}
 */
export function getStepByField(field: string): string | null {
  return field ? prevaled.KeyToStepMap[field] : null;
}

/**
 * Returns a list of fields given a step id
 *
 * @export
 * @param {string} field
 * @returns {string[]}
 */
export function getStepFields(field: string): Array<*> {
  return _.filter(prevaled.StepToKeyMap, step => step.fields.includes(field));
}

// eslint-disable-next-line no-unused-vars
export function getNextFieldsByStep(step: string): string[] {
  const index = _.findIndex(prevaled.StepToKeyMap, s => s.id === step);
  const remaining = _.slice(prevaled.StepToKeyMap, index)
    .filter(i => i)
    .map(i => i.fields);
  debug(step, remaining);
  return _.flatten(remaining);
}

/**
 * Returns a list of fields after the given fields
 * @param {string} field
 * @returns {string[]}
 */
export function getNextFields(field: string, forSameStep?: boolean) {
  const step = getStepByField(field);
  const stepIndex = _.findIndex(prevaled.StepToKeyMap, ['id', step]);
  const remaininSteps = _.slice(prevaled.StepToKeyMap, stepIndex + 1);

  // Get any remaining fields for this step
  const partialStep = prevaled.StepToKeyMap[stepIndex];
  const fieldIndex = _.findIndex(partialStep.fields, f => f === field);

  const rest = _.slice(partialStep.fields, fieldIndex + 1);

  if (forSameStep) {
    return rest;
  }

  // $FlowIgnore
  return [].concat(
    rest,
    remaininSteps.reduce((a, s) => [].concat(s.fields, a), []),
  );
}

export function getFieldData(field: string) {
  const step = getStepByField(field);
  if (!step) return {};
  const data = _.get(prevaled.stepData, [step, 'steps']);
  return _.reduce(
    data,
    (s: Object, d: Object) => _.get(d, ['fields', field], {}),
    {},
  );
}



// WEBPACK FOOTER //
// ./src/utils/stepHelpers.js